import { render, staticRenderFns } from "./button-call-to-action.vue?vue&type=template&id=71b062ad&scoped=true&"
import script from "./button-call-to-action.vue?vue&type=script&lang=js&"
export * from "./button-call-to-action.vue?vue&type=script&lang=js&"
import style0 from "./button-call-to-action.vue?vue&type=style&index=0&id=71b062ad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b062ad",
  null
  
)

export default component.exports